/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LeveeMaterialEnum } from "./LeveeMaterialEnum";
import {
  LeveeMaterialEnumFromJSON,
  LeveeMaterialEnumFromJSONTyped,
  LeveeMaterialEnumToJSON,
  LeveeMaterialEnumToJSONTyped,
} from "./LeveeMaterialEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface PatchedBreach
 */
export interface PatchedBreach {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  potentialBreach?: any | null;
  /**
   * The id of the flowline ('levl' in the geojson)
   */
  lineId?: number;
  /**
   * Duration till maximum depth, in seconds
   */
  durationTillMaxDepth?: number;
  /**
   * The maximum breach depth relative to the crest level, in meters
   */
  maximumBreachDepth?: number;
  /**
   *
   */
  leveeMaterial?: LeveeMaterialEnum;
  /**
   * initial width in meters
   */
  initialWidth?: number;
  /**
   *
   */
  dischargeCoefficientPositive?: number | null;
  /**
   *
   */
  dischargeCoefficientNegative?: number | null;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
}

/**
 * Check if a given object implements the PatchedBreach interface.
 */
export function instanceOfPatchedBreach(value: object): value is PatchedBreach {
  return true;
}

export function PatchedBreachFromJSON(json: any): PatchedBreach {
  return PatchedBreachFromJSONTyped(json, false);
}

export function PatchedBreachFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedBreach {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    potentialBreach:
      json["potential_breach"] === undefined
        ? undefined
        : json["potential_breach"] === null
        ? null
        : json["potential_breach"],
    lineId: json["line_id"] == null ? undefined : json["line_id"],
    durationTillMaxDepth:
      json["duration_till_max_depth"] == null ? undefined : json["duration_till_max_depth"],
    maximumBreachDepth:
      json["maximum_breach_depth"] == null ? undefined : json["maximum_breach_depth"],
    leveeMaterial:
      json["levee_material"] == null
        ? undefined
        : LeveeMaterialEnumFromJSON(json["levee_material"]),
    initialWidth: json["initial_width"] == null ? undefined : json["initial_width"],
    dischargeCoefficientPositive:
      json["discharge_coefficient_positive"] === undefined
        ? undefined
        : json["discharge_coefficient_positive"] === null
        ? null
        : json["discharge_coefficient_positive"],
    dischargeCoefficientNegative:
      json["discharge_coefficient_negative"] === undefined
        ? undefined
        : json["discharge_coefficient_negative"] === null
        ? null
        : json["discharge_coefficient_negative"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"] == null ? undefined : json["offset"],
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
  };
}

export function PatchedBreachToJSON(json: any): PatchedBreach {
  return PatchedBreachToJSONTyped(json, false);
}

export function PatchedBreachToJSONTyped(
  value?: Omit<PatchedBreach, "url" | "simulation" | "id" | "uid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    potential_breach: value["potentialBreach"],
    line_id: value["lineId"],
    duration_till_max_depth: value["durationTillMaxDepth"],
    maximum_breach_depth: value["maximumBreachDepth"],
    levee_material: LeveeMaterialEnumToJSON(value["leveeMaterial"]),
    initial_width: value["initialWidth"],
    discharge_coefficient_positive: value["dischargeCoefficientPositive"],
    discharge_coefficient_negative: value["dischargeCoefficientNegative"],
    offset: value["offset"],
  };
}
